export default __webpack_public_path__ + "static/media/boschsans_bold.bf00c09e.woff";